import styles from "../index.module.scss";
import cn from "classnames";

const ChartTabItem = ({ isActive, onClick, children, disabled }) => {
  return (
    <button
      className={cn(
        styles.tab_item,
        isActive && styles.tab_selected,
        disabled && styles.tab_disabled
      )}
      onClick={!disabled ? onClick : null}
      type="button"
    >
      {children}
    </button>
  );
};
export default ChartTabItem;
